var _path, _path2, _g, _rect, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStep2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 320,
    viewBox: "0 0 500 320",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2485_25765)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M451 47H271C268.636 46.9999 266.295 47.4676 264.111 48.3762C261.927 49.2849 259.943 50.6168 258.271 52.2958C256.6 53.9749 255.274 55.9682 254.37 58.1619C253.465 60.3557 253 62.7069 253 65.0813V131.496C253 232.761 338.298 266.359 355.375 272.065C359.022 273.312 362.978 273.312 366.625 272.065C383.725 266.359 469 232.761 469 131.496V65.0813C469 60.2861 467.104 55.6872 463.728 52.2963C460.353 48.9054 455.774 47.0003 451 47Z",
    fill: "#2C2B30"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2485_25765",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 253,
    y: 47,
    width: 216,
    height: 227
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M451 47.0002H271C268.636 47.0002 266.295 47.4678 264.111 48.3765C261.927 49.2852 259.943 50.617 258.271 52.2961C256.6 53.9751 255.274 55.9684 254.37 58.1622C253.465 60.3559 253 62.7072 253 65.0816V131.496C253 232.762 338.298 266.359 355.375 272.066C359.022 273.312 362.978 273.312 366.625 272.066C383.725 266.359 469 232.762 469 131.496V65.0816C469 60.2864 467.104 55.6875 463.728 52.2966C460.353 48.9057 455.774 47.0005 451 47.0002Z",
    fill: "#2C2B30"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2485_25765)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 182,
    y1: 129.339,
    x2: 754,
    y2: 129.339,
    stroke: "white",
    strokeOpacity: 0.04,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 182,
    y1: 201.81,
    x2: 754,
    y2: 201.81,
    stroke: "white",
    strokeOpacity: 0.04,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 182,
    y1: 56.8689,
    x2: 754,
    y2: 56.8689,
    stroke: "white",
    strokeOpacity: 0.04,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 182,
    y1: 238.045,
    x2: 754,
    y2: 238.045,
    stroke: "white",
    strokeOpacity: 0.04,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 182,
    y1: 93.1042,
    x2: 754,
    y2: 93.1042,
    stroke: "white",
    strokeOpacity: 0.04,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 182,
    y1: 165.575,
    x2: 754,
    y2: 165.575,
    stroke: "white",
    strokeOpacity: 0.04,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 442.086,
    y1: -65,
    x2: 442.086,
    y2: 397,
    stroke: "white",
    strokeOpacity: 0.04,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 320.994,
    y1: -65,
    x2: 320.994,
    y2: 397,
    stroke: "white",
    strokeOpacity: 0.04,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 260.447,
    y1: -65,
    x2: 260.447,
    y2: 397,
    stroke: "white",
    strokeOpacity: 0.04,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 381.539,
    y1: -65,
    x2: 381.539,
    y2: 397,
    stroke: "white",
    strokeOpacity: 0.04,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 351.266,
    y1: -65,
    x2: 351.266,
    y2: 397,
    stroke: "white",
    strokeOpacity: 0.04,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 290.721,
    y1: -65,
    x2: 290.721,
    y2: 397,
    stroke: "white",
    strokeOpacity: 0.04,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 411.812,
    y1: -65,
    x2: 411.812,
    y2: 397,
    stroke: "white",
    strokeOpacity: 0.04,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.15 238.392H372.909L377.45 242.733L381.423 246.696V274.628H351.15V238.392Z",
    fill: "#242426"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.809 238.642L377.277 242.914L381.174 246.8V274.378H351.4V238.642H372.809Z",
    stroke: "white",
    strokeOpacity: 0.04,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.01,
    y: -18.7791,
    width: 500.14,
    height: 275.039,
    stroke: "white",
    strokeOpacity: 0.04,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.643 20.7156H312.401L316.942 25.0563L320.916 29.0195V56.9509H290.643V20.7156Z",
    fill: "#242426"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.371 93.5637H282.13L286.671 97.9044L290.644 101.868V129.799H260.371V93.5637Z",
    fill: "#242426"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412 93H433.759L438.3 97.3407L442.273 101.304V129.235H412V93Z",
    fill: "#242426"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 333,
    y: 132,
    width: 56,
    height: 56,
    rx: 28,
    fill: "#242426"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M380.799 140.201C375.763 135.165 368.998 132.238 361.879 132.014C354.761 131.79 347.825 134.287 342.483 138.997L361 160L380.799 140.201Z",
    fill: "url(#paint0_linear_2485_25765)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M380.798 140.201C375.762 135.165 368.997 132.238 361.879 132.014C354.76 131.79 347.824 134.287 342.482 138.997",
    stroke: "url(#paint1_linear_2485_25765)",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M360.5 169C365.747 169 370 164.747 370 159.5C370 154.253 365.747 150 360.5 150C355.253 150 351 154.253 351 159.5C351 164.747 355.253 169 360.5 169Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M371 170L369 168",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2485_25765",
    x1: 361,
    y1: 160,
    x2: 361,
    y2: 131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CCFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#44CCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2485_25765",
    x1: 380.798,
    y1: 136.101,
    x2: 342.482,
    y2: 136.101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D2FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#44CCFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2485_25765"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 216,
    height: 226,
    fill: "white",
    transform: "translate(253 46.9995)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep2);
export default __webpack_public_path__ + "static/media/step2.80100e4d62acd655b45bf46ded4538c3.svg";
export { ForwardRef as ReactComponent };